import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { EVENT_EMITTER_TYPE } from '../../../../constants';
import Emitter from '../../../../services/EmitterService';
import utils from '../../../../utils';
import { ACTION_COMMANDS_EVENT_TYPE, ACTION_COMMANDS_TYPE } from '../../constants';

var setTooltipCommands = function setTooltipCommands(actionCommand) {
  var _actionCommand$toolti, _actionCommand$toolti2, _actionCommand$toolti3, _actionCommand$toolti4;

  Emitter.emit(EVENT_EMITTER_TYPE.ACTION_COMMANDS, {
    actionType: ACTION_COMMANDS_TYPE.NOTIFY_TRIGGER_PROCESSED_REQUEST,
    data: {
      event: ACTION_COMMANDS_EVENT_TYPE.DISPLAY_APP_TOOLTIP,
      triggerExecution: actionCommand === null || actionCommand === void 0 ? void 0 : (_actionCommand$toolti = actionCommand.tooltip) === null || _actionCommand$toolti === void 0 ? void 0 : (_actionCommand$toolti2 = _actionCommand$toolti.onDisplayAction) === null || _actionCommand$toolti2 === void 0 ? void 0 : _actionCommand$toolti2.triggerExecution,
      payload: actionCommand === null || actionCommand === void 0 ? void 0 : (_actionCommand$toolti3 = actionCommand.tooltip) === null || _actionCommand$toolti3 === void 0 ? void 0 : (_actionCommand$toolti4 = _actionCommand$toolti3.onDisplayAction) === null || _actionCommand$toolti4 === void 0 ? void 0 : _actionCommand$toolti4.payload
    }
  });
  Emitter.emit(EVENT_EMITTER_TYPE.ACTION_COMMANDS, {
    actionType: ACTION_COMMANDS_TYPE.CLEAR_ACTION_COMMAND
  });
};

export var handleTooltip = function handleTooltip(details, props, actionCommand) {
  props.setTooltipDetails(details);
  props.shouldShowTooltip(true);
  setTimeout(function () {
    var out = _objectSpread(_objectSpread({}, details), {}, {
      animationState: utils.getPlatform() === 'web' ? 'AnimationFadeOut' : 'out'
    });

    props.setTooltipDetails(out);
  }, 3500);
  setTimeout(function () {
    setTooltipCommands(actionCommand);
  }, 4000);
};